import React,{ useEffect, useState } from 'react';
import './Content.css';
import { useNavigate } from 'react-router-dom';


export default function Content(props) {
    const { color, setColor} = props;
    let navigate = useNavigate();
    const [crypto, setCrypto] = useState([]);

    useEffect(() => {
        setCrypto(props.currentItems);
    }, [props.currentItems])
    

    // useEffect(() => {
    //     fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=100&page=1&sparkline=false')
    //         .then(res => res.json())
    //         .then(data => {
    //             console.log(data);
    //             setCrypto(data);
    //         });
    // }, [])


    return (
        <div className='container'>

            <div>
                <table className={`table table-${color} table-hover`}>   
                    <thead>
                        <tr>
                            <th scope="col">COIN</th>
                            <th scope="col">PRICE</th>
                            <th scope="col">24h CHANGE</th>
                            <th scope="col">MARKET CAP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            crypto!== null && crypto.map(item => 
                                <tr onClick={()=> navigate(`/coin/${item.id}`)} key={item.id}>
                                    <td scope="row"><img style={{height:"6vh"}} src={item.image}/><h6 className='mt-1'>{item.name}</h6></td>
                                    <td className=''>₹ {item.current_price.toLocaleString()}</td>
                                    <td style={{color: item.price_change_percentage_24h  > 0 ? "green":"red", fontWeight:500}}>{item.price_change_percentage_24h.toFixed(2)} % </td>
                                    <td>₹ {item.market_cap.toString().slice
                                                (0,-9)} M </td>
                                    
                                </tr>
                            )
                        }

                    </tbody>
                </table>
            </div>
        </div>
    )
}
